// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_20eL0tpCHNVYS7xYho_KRs","marketText":"_13K-c3W69j7DnuxzF7PY8N","customButtonContainer":"_1sOgEx2fuO2PBcDpLkA4nM","innerText":"_10BvHBquHRj_NuPjF7TIvw"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/oddsCardSoccer3.css
// module id = 804
// module chunks = 0